import { useEffect, useState } from "react";
import { toast } from "sonner";
import { publicApi, formatPublicError, isValidMobile, honeypotOf } from "../lib/publicApi";
import { useT } from "../lib/i18n";

export function ReserveOnline({ stock }) {
  const { t } = useT();
  const [quote, setQuote] = useState(null);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", mobile: "", accept: false });
  const [busy, setBusy] = useState(false);
  useEffect(() => { publicApi.get(`/vehicles/${encodeURIComponent(stock)}/reserve-online`).then((r) => setQuote(r.data)).catch(() => setQuote(null)); }, [stock]);
  if (!quote?.available) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!isValidMobile(form.mobile)) { toast.error(t("enquiry.mobile_invalid")); return; }
    setBusy(true);
    try {
      const { data } = await publicApi.post(`/vehicles/${encodeURIComponent(stock)}/reserve-online`,
        { name: form.name, mobile: form.mobile, accept_terms: form.accept, website: honeypotOf(e) });
      sessionStorage.setItem("last_payment_attempt", data.attempt_id);
      window.location.assign(data.checkout_url);
    } catch (err) { toast.error(formatPublicError(err)); setBusy(false); }
  };

  return (
    <div className="vd-priceblock" data-testid="reserve-online-block" style={{ marginTop: 16 }}>
      <div style={{ fontWeight: 600, marginBottom: 4 }}>{t("pay.reserve_title")}</div>
      <div style={{ fontSize: 13, color: "var(--grey-600)", marginBottom: 12 }} data-testid="reserve-deposit-amount">
        {t("pay.deposit_is", { amount: `OMR ${quote.amount}` })}
      </div>
      {quote.on_hold_until ? (
        <div style={{ fontSize: 13 }} data-testid="reserve-on-hold">{t("pay.on_hold")}</div>
      ) : !open ? (
        <button type="button" className="pub-cta big full" onClick={() => setOpen(true)} data-testid="reserve-online-btn">{t("pay.reserve_cta")}</button>
      ) : (
        <form className="enquiry-form" onSubmit={submit} data-testid="reserve-online-form">
          <input type="text" name="website" tabIndex={-1} autoComplete="off" style={{ display: "none" }} data-testid="reserve-honeypot" />
          <input placeholder={t("enquiry.your_name")} required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="reserve-name" />
          <input placeholder={t("enquiry.mobile")} required inputMode="tel" value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} data-testid="reserve-mobile" />
          <label style={{ display: "flex", gap: 8, fontSize: 13, alignItems: "flex-start" }}>
            <input type="checkbox" checked={form.accept} onChange={(e) => setForm({ ...form, accept: e.target.checked })} required data-testid="reserve-terms" style={{ width: 20, height: 20 }} />
            <span>{t("pay.terms")}</span>
          </label>
          <button type="submit" disabled={busy} data-testid="reserve-submit">{busy ? t("pay.redirecting") : t("pay.pay_now", { amount: `OMR ${quote.amount}` })}</button>
        </form>
      )}
    </div>
  );
}
